import React from "react";
import Header from "../Header";
import MainComponent from "../MainComponent";
import Footer from "../Footer";
import FooterDown from "../FooterDown";
import Disclaimer from "./Disclaimer";

const DisclaimerPage = () => {
  return (
    <div>
      <Header />
      <MainComponent type='disclaimer'/>
        <Disclaimer />
      <Footer />
      <FooterDown />
    </div>
  );
};

export default DisclaimerPage;
